import type { WorkflowStatusCountResponse } from './types'
import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'

export const isWorkflowStatus = (
  value: string
): value is WorkflowFilterStatus => {
  return [
    'show-all',
    'todos',
    'checks',
    'unreconciled',
    'not_prepared',
    'unreviewed_by_me',
    'prepared_unreviewed_by_me',
    'starred',
  ].includes(value)
}

export const isValidWorkflowStatusResponseKey = (
  value: string
): value is keyof WorkflowStatusCountResponse => {
  return [
    'todos',
    'checks',
    'unreconciled',
    'notPrepared',
    'unreviewedByMe',
    'preparedUnreviewedByMe',
    'starred',
    'total',
  ].includes(value)
}
